/**
 * list-export — JEDEN adres eksportu widoku listy do CSV (E16) dla wszystkich kartotek.
 *
 * Serwer: `GET /api/list-export/<cel>` (moduły własne: `GET /api/list-export/module/<id|slug>`) —
 * trasa `app/api/list-export/[...target]` + rejestr `apps/api/lib/list-export/registry.ts`
 * (cel → opis listy, bramka modułu, dodatki doklejane po silniku). Panel: wspólny hook
 * `useEngineListExport({ target })` / `listExportPath(...)`. Dodając eksport kolejnej kartoteki,
 * dopisz jej cel TUTAJ i wpis w rejestrze serwera — bez nowej trasy.
 *
 * Cel = segment adresu listy tej kartoteki (`/api/<cel>` = lista, `/api/list-export/<cel>` = eksport).
 */

export const LIST_EXPORT_TARGETS = [
  'contractors',
  'employees',
  'companies',
  'users',
  'products',
  'purchase-invoices',
  'sale-invoices',
  'contracts',
  'letters',
  'commercial-docs',
  'internal-docs',
  'module',
] as const;

export type ListExportTarget = (typeof LIST_EXPORT_TARGETS)[number];

export function isListExportTarget(value: string): value is ListExportTarget {
  return (LIST_EXPORT_TARGETS as readonly string[]).includes(value);
}

/**
 * Adres eksportu (bez prefiksu `/api` — panel dokłada go w kliencie HTTP). Moduł własny wymaga
 * id albo sluga modułu: `listExportPath('module', moduleId)`.
 */
export function listExportPath(target: ListExportTarget, moduleIdOrSlug?: string): string {
  if (target === 'module') {
    if (!moduleIdOrSlug) throw new Error('listExportPath: moduł własny wymaga id albo sluga');
    return `/list-export/module/${encodeURIComponent(moduleIdOrSlug)}`;
  }
  return `/list-export/${target}`;
}
